import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { Header } from '../Components/Header/Header'
import { About } from '../Components/About/About'
import { Work } from '../Components/Work/Work'
import { Pricing } from '../Components/Pricing/Pricing'
import { Important } from '../Components/Important/Important'
import { Footer } from '../Components/Footer/Footer'
import { Navbar } from '../Components/Navbar/Navbar'

export const Layout = () => {
  return (
    <Flex direction={'column'} width={'100%'} height={'100%'}>
        <Navbar/>
        <Header/>
        <About/>
        <Work/>
        <Pricing/>
        <Important/>
        <Footer/>
    </Flex>
  )
}
